import { connect } from 'react-redux'

import { getActivityProQuote, getActivityProQuoteAuthor } from 'store/entities/activity/selectors'
import ActivityQuote from './ActivityQuote'

const mapStateToProps = state => ({
  proQuote: getActivityProQuote(state),
  proQuoteAuthor: getActivityProQuoteAuthor(state),
})

export default connect(mapStateToProps)(ActivityQuote)
